import * as React from 'react';

import { cn } from '../../services/lib/utils';
import { SearchIcon } from 'lucide-react';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement | HTMLTextAreaElement> {
  as?: 'input' | 'textarea';
  theme?: 'new' | 'default';
  showSearchIcon?: boolean;
  label?: string;
}

const Input = React.forwardRef<HTMLInputElement | HTMLTextAreaElement, InputProps>(
  ({ className, type, theme = 'default', as = 'input', showSearchIcon = false, label, ...props }, ref) => {
    const borders =
      theme === 'default'
        ? '!text-sh-xxxs border-gray-300 text-gray-500 shadow-sm'
        : '!text-sh-xxs border-gray-300 bg-white ring-offset-background placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 text-black ';

    const inputPadding = showSearchIcon ? 'pr-10' : '';

    const inputElement =
      as === 'input' ? (
        <input
          type={type}
          className={cn('mt-1 block h-10 w-full rounded-lg border px-3 py-2', className, borders, inputPadding)}
          ref={ref as React.RefObject<HTMLInputElement>}
          {...props}
        />
      ) : (
        <textarea
          className={cn('mt-1 block w-full rounded-lg border px-3 py-2 ', className, borders, inputPadding)}
          ref={ref as React.RefObject<HTMLTextAreaElement>}
          {...props}
        />
      );

    if (showSearchIcon) {
      return (
        <div>
          <p className="mb-2 font-cadiz text-sh-xs font-bold">{label}</p>

          <div className="relative">
            {inputElement}
            <SearchIcon className="absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-black" />
          </div>
        </div>
      );
    }

    return inputElement;
  },
);
Input.displayName = 'Input';

export { Input };
